var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellConcierge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504 432H8C3.578 432 0 435.578 0 440S3.578 448 8 448H504C508.422 448 512 444.422 512 440S508.422 432 504 432ZM32 392C36.422 392 40 388.422 40 384C40 264.891 136.891 168 256 168S472 264.891 472 384C472 388.422 475.578 392 480 392S488 388.422 488 384C488 258.779 388.201 156.67 264 152.404V80H312C316.422 80 320 76.422 320 72S316.422 64 312 64H200C195.578 64 192 67.578 192 72S195.578 80 200 80H248V152.404C123.799 156.67 24 258.779 24 384C24 388.422 27.578 392 32 392Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellConcierge);
export default __webpack_public_path__ + "static/media/bell-concierge.d10fe6096a50df89be04022523c6e44c.svg";
export { ForwardRef as ReactComponent };